import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { addQrcodeJs } from "@/common/add-js";
let PiQrcodeShow = class PiQrcodeShow extends Vue {
    constructor() {
        super(...arguments);
        this.win = window;
        this.qrcodeObj = {};
        this.isInit = false;
    }
    getVisible() {
        this.init();
    }
    async init() {
        await addQrcodeJs();
        this.qrcodeShow();
    }
    qrcodeShow() {
        if (!this.win.QRCode) {
            setTimeout(() => {
                this.qrcodeShow();
            }, 200);
        }
        else {
            if (this.url != "") {
                this.$nextTick(() => {
                    const divObj = this.$refs["qrcodeDiv"] || {};
                    divObj.innerHTML = "";
                    if (!this.isInit) {
                        this.isInit = true;
                        this.qrcodeObj = new this.win.QRCode(divObj, {
                            width: 200,
                            height: 200,
                        });
                    }
                    this.qrcodeObj.makeCode(this.url);
                });
            }
        }
    }
    mounted() {
        this.init();
    }
};
__decorate([
    Prop({ default: "" })
], PiQrcodeShow.prototype, "url", void 0);
__decorate([
    Prop({ default: 200 })
], PiQrcodeShow.prototype, "width", void 0);
__decorate([
    Prop({ default: 200 })
], PiQrcodeShow.prototype, "height", void 0);
__decorate([
    Prop({ default: false })
], PiQrcodeShow.prototype, "isShowUrl", void 0);
__decorate([
    Watch("url")
], PiQrcodeShow.prototype, "getVisible", null);
PiQrcodeShow = __decorate([
    Component
], PiQrcodeShow);
export default PiQrcodeShow;
